import React, { useEffect, useState } from "react";
import { Bars } from "react-loader-spinner";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import axiosInstance from "../../../Shared/axiosInstance"; // استخدمنا الـ instance الجاهز

export default function Brands() {
  const [brands, setBrands] = useState(null);
  const [load, setLoad] = useState(false);

  // جلب كل العلامات التجارية
  async function getAllBrands() {
    setLoad(true);
    try {
      const { data } = await axiosInstance.get("/Brand");
      setBrands(data?.data);
    } catch (error) {
      console.error("خطأ عند جلب العلامات التجارية:", error);
      Swal.fire({
        title: "خطأ!",
        text: error.response?.data?.message || "فشل في جلب العلامات التجارية.",
        icon: "error",
      });
    }
    setLoad(false);
  }

  // حذف العلامة التجارية
  async function handleDelete(brandId) {
    try {
      const result = await Swal.fire({
        title: "هل أنت متأكد؟",
        text: "لن تستطيع التراجع عن هذا!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "نعم، احذفها!",
      });

      if (result.isConfirmed) {
        setLoad(true);

        const response = await axiosInstance.delete(`/Brand/${brandId}`);

        if (response.data.status === 200) {
          await Swal.fire({
            title: "تم الحذف!",
            text: response.data.message || "تم حذف العلامة التجارية بنجاح.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
          await getAllBrands();
        } else {
          Swal.fire({
            title: "خطأ!",
            text: response.data.message || "فشل في حذف العلامة التجارية.",
            icon: "error",
          });
        }
      }
    } catch (error) {
      console.error("خطأ عند حذف العلامة التجارية:", error);
      Swal.fire({
        title: "خطأ!",
        text: error.response?.data?.message || "فشل في حذف العلامة التجارية.",
        icon: "error",
      });
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    getAllBrands();
  }, []);

  // Loader
  if (load) {
    return (
      <div className="vh-100 d-flex align-items-center justify-content-center flex-column">
        <Bars height="80" width="80" color="#2563eb" ariaLabel="loading" />
        <p className="mt-3" style={{ color: "#64748b", fontSize: "18px" }}>
          جاري تحميل العلامات التجارية...
        </p>
      </div>
    );
  }

  return (
    <div className="container py-5" style={{ maxWidth: "1200px" }}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4 mt-5 pt-5">
        <div>
          <h2 style={{ color: "#2563eb", fontWeight: "700", fontSize: "28px", marginBottom: "4px" }}>
            قائمة العلامات التجارية
          </h2>
          <small style={{ color: "#64748b", fontSize: "14px" }}>
            {brands ? `عدد العلامات التجارية: ${brands.length}` : "جارٍ التحميل..."}
          </small>
        </div>
        <Link to="/add-brand">
          <button
            style={{
              background: "#2563eb",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "6px",
              border: "none",
              fontWeight: "600",
              fontSize: "15px",
              boxShadow: "0 2px 8px rgba(37, 99, 235, 0.3)",
              transition: "all 0.3s ease",
            }}
          >
            <i className="bi bi-plus-circle me-1"></i> إضافة علامة تجارية
          </button>
        </Link>
      </div>

      {/* Brands Table */}
      {brands && brands.length > 0 ? (
        <div className="table-responsive">
          <table
            className="table mb-0"
            style={{
              border: "1px solid #dbeafe",
              borderRadius: "8px",
              overflow: "hidden",
              boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
              textAlign: "center",
            }}
          >
            <thead style={{ background: "#dbeafe" }}>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>اسم العلامة التجارية</th>
                <th style={thStyle}>الإجراءات</th>
              </tr>
            </thead>
            <tbody>
              {brands.map((br, index) => (
                <tr key={br.id} style={{ background: index % 2 === 0 ? "#f8fafc" : "#ffffff" }}>
                  <td style={tdStyle}>{index + 1}</td>
                  <td style={{ ...tdStyle, fontWeight: 700, color: "#2563eb" }}>{br.name}</td>
                  <td style={tdStyle}>
                    <div className="d-flex justify-content-center gap-2 flex-wrap">
                      <Link to={`/brands/${br.id}`}>
                        <button style={actionBtnStyle("#22c55e")}>
                          <i className="bi bi-eye me-1"></i> عرض
                        </button>
                      </Link>
                      <Link to={`/update-brand/${br.id}`}>
                        <button style={actionBtnStyle("#2563eb")}>
                          <i className="bi bi-pencil-square me-1"></i> تعديل
                        </button>
                      </Link>
                      <button
                        style={actionBtnStyle("#dc2626")}
                        onClick={() => handleDelete(br.id)}
                      >
                        <i className="bi bi-trash me-1"></i> حذف
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div
          style={{
            background: "#fff",
            border: "1px solid #dbeafe",
            borderRadius: "8px",
            padding: "60px 20px",
            textAlign: "center",
            boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
          }}
        >
          <i
            className="bi bi-folder"
            style={{ fontSize: "64px", color: "#94a3b8", marginBottom: "20px" }}
          ></i>
          <h4 style={{ color: "#475569", fontWeight: "600", marginBottom: "8px" }}>
            لا توجد علامات تجارية
          </h4>
          <p style={{ color: "#64748b", fontSize: "15px", marginBottom: "20px" }}>
            ابدأ بإنشاء أول علامة تجارية
          </p>
          <Link to="/add-brand">
            <button
              style={{
                background: "#2563eb",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "6px",
                border: "none",
                fontWeight: "600",
                fontSize: "15px",
              }}
            >
              <i className="bi bi-plus-circle me-1"></i> إنشاء أول علامة تجارية
            </button>
          </Link>
        </div>
      )}
    </div>
  );
}

// Styles
const thStyle = {
  color: "#1e40af",
  fontSize: "14px",
  padding: "12px 8px",
  fontWeight: "600",
  border: "1px solid #bfdbfe",
};

const tdStyle = {
  padding: "12px 8px",
  border: "1px solid #e0e7ff",
  fontSize: "18px",
  fontWeight: "600",
  color: "#475569",
};

const actionBtnStyle = (color) => ({
  background: color,
  color: "#fff",
  padding: "6px 12px",
  borderRadius: "6px",
  border: "none",
  fontWeight: "600",
  fontSize: "13px",
  cursor: "pointer",
  transition: "all 0.3s ease",
});
